import React from 'react';

import {
  RequestNumberColumn,
  StoreIconColumn,
  OrderNumberColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
  StatusColumn,
  TrackingNumberColumn,
  CarrierServiceColumn,
  SourceColumn,
} from '../../grids/columns';
import { SSRBaseGrid } from '../ssr-base-grid';
import { NoSsrCompletedReturnsPlaceholder } from './placeholders/no-ssr-completed-returns-placeholder';

import status from '../../grids/filters/options/status';

const columns = [
  RequestNumberColumn,
  StoreIconColumn,
  OrderNumberColumn,
  SourceColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  TrackingNumberColumn,
  CarrierServiceColumn,
  AmountColumn,
  StatusColumn,
];

const viewSpecificFilters = [status];

export const SSRCompletedGrid = () => {
  return (
    <SSRBaseGrid columns={columns} noResultsPlaceholder={<NoSsrCompletedReturnsPlaceholder />} viewSpecificFilters={viewSpecificFilters} />
  );
};
